var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-block" }, [
    _c("h3", [_vm._v("Inspection Emails")]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "form-row agent-fees" },
        [
          _c("b-form-group", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.inspectionEmails.length
                  ? [
                      _vm._l(_vm.inspectionEmails, function(inspection, index) {
                        return [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "name-" + index } },
                                    [_vm._v("Name")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    staticClass: "w-100 mt-1",
                                    attrs: {
                                      id: "name-" + index,
                                      type: "text"
                                    },
                                    on: { input: _vm.emitInput },
                                    model: {
                                      value: inspection.name,
                                      callback: function($$v) {
                                        _vm.$set(inspection, "name", $$v)
                                      },
                                      expression: "inspection.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "email-" + index } },
                                    [_vm._v("Email")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    staticClass: "w-100 mt-1",
                                    attrs: {
                                      id: "email-" + index,
                                      type: "email"
                                    },
                                    on: { input: _vm.emitInput },
                                    model: {
                                      value: inspection.email,
                                      callback: function($$v) {
                                        _vm.$set(inspection, "email", $$v)
                                      },
                                      expression: "inspection.email"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-3" },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "btn mt-2 mt-sm-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeInspectionEmail(
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Remove\n                                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.inspectionEmailErrors[index] &&
                          _vm.inspectionEmailErrors[index].length
                            ? _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "alert alert-danger" },
                                    _vm._l(
                                      _vm.inspectionEmailErrors[index],
                                      function(err) {
                                        return _c("div", [
                                          _vm._v("- " + _vm._s(err))
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "isolated-add-button row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("b-btn", { on: { click: _vm.addInspectionEmail } }, [
                        _vm._v("Add New")
                      ])
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f7e7818", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f7e7818","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/InspectionEmails.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7f7e7818","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/InspectionEmails.vue
// module chunks = 0